<template>
  <div>
    <message-modal />

    <div>
      <main-header />
      <tabs
        ref="tabs"
        :options="{ useUrlFragment: false, defaultTabHash: 'general' }"
        class="spl-edit-tabs"
        @changed="onTabChanged">
        <tab id="general" name="General">
          <report-edit-general />
        </tab>
        <tab id="columns" name="Columns">
          <report-edit-columns />
        </tab>
        <tab id="defaultFilter" name="Default Filter">
          <report-edit-default-filter />
        </tab>
      </tabs>
      <report-edit-action-bar
        :active-tab="activeTab"
        @onNext="handleNext"
        @onCancel="handleCancel" />
      <div v-if="isLoading" class="spl-load-img" />
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import { mapState, mapMutations, mapActions } from 'vuex'
import MessageDialog from '@/components/shared/message-dialog'
import { create } from 'vue-modal-dialogs'
import { cloneDeep } from 'lodash'
import store from '@/store'
const messageDialog = create(MessageDialog, 'content')

export default {
  mixins: [Helpers],
  data () {
    return {
      isLoading: false,
      activeTab: 'general',
      tabs: ['general', 'columns', 'defaultFilter']
    }
  },
  computed: {
    ...mapState('report', ['loadedReport', 'currentEditReport'])
  },
  beforeRouteEnter (to, from, next) {
    // load the report before proceding when we enter an edit route
    if (to.name === 'report-edit') {
      store.dispatch('report/loadReport', to.params.id).then(() => {
        next()
      }).catch((error) => {
        next()
        window.bus.$emit('openErrorModal', error.ExceptionMessage)
      })
    } else {
      next()
    }
  },
  created () {
    if (this.$route.name === 'report-create') {
      // Set a default report when creating a new one
      this.setCurrentEditReport({
        Report_Name: '',
        Report_Filter: {},
        Report_Layout: [],
        Date_Range_From: -1,
        Date_Range_To: -1,
        Last_Weeks: -1,
        Last_Months: -1,
        Last_Years: -1,
        Private: false,
        Base_On_Problem_Report: false
      })
    } else {
      this.setCurrentEditReport(cloneDeep(this.loadedReport))
    }
  },
  methods: {
    ...mapMutations('report', ['setCurrentEditReport']),
    ...mapActions('report', ['saveReport', 'loadReport']),

    // ************************ Show Login is set to true if teh user is not logged in or if the token has expired.
    validateAndSend () {
      // Validate the report before sending it
      var valid = true
      var validationMessage =''
      if (this.reportNameMissing()) {
        valid = false
        validationMessage = 'Please enter the Report Name.'
      } else if (this.colmunsMissing) {
        valid = false
        validationMessage = 'Please choose at least one column.'
      } else if (this.dateRangesMissing()) {
        valid = false
        validationMessage = 'Please choose a valid date range (only values  greater than zero are allowed).'
      } else if (this.dateFromAfterDateTo()) {
        valid = false
        validationMessage = "Please choose a valid date range where 'From' is before 'To'."
      }

      if (valid) {
        this.isLoading = true
        // saving the report to the database
        this.saveReport(this.currentEditReport).then((response) => {
          this.isLoading = false
          this.$router.push('/report-detail/' + response.data)
        }).catch((error) => {
          this.isLoading = false
          messageDialog('Something went wrong: ' + error.ExceptionMessage)
        })
      } else {
        messageDialog(validationMessage)
      }
    },
    reportNameMissing () {
      if (!this.currentEditReport.Report_Name || this.currentEditReport.Report_Name === '') {
        return true
      }
      return false
    },
    columnsMissing () {
      if (!this.currentEditReport.Report_Layout || this.currentEditReport.Report_Layout.length === 0) {
        return true
      }
      return false
    },
    dateRangesMissing () {
      if (this.currentEditReport.Last_Weeks <= 0 &&
              this.currentEditReport.Last_Months <= 0 &&
              this.currentEditReport.Last_Years <= 0 &&
              (this.currentEditReport.Date_Range_From < 0 ||
                  this.currentEditReport.Date_Range_To < 0)) {
        return true
      }
      return false
    },
    dateFromAfterDateTo () {
      if (this.currentEditReport.Date_Range_From < this.currentEditReport.Date_Range_To) {
        return true
      }
      return false
    },
    onTabChanged (value) {
      this.activeTab = value.tab.id
    },
    // *********************** Handle Actionbar *************************
    handleNext () {
      // Tab handling
      if (this.activeTab === 'general') {
        this.$refs.tabs.selectTab('#columns')
      } else if (this.activeTab === 'columns') {
        this.$refs.tabs.selectTab('#defaultFilter')
      } else if (this.activeTab === 'defaultFilter') {
        this.validateAndSend()
      }
    },
    handleCancel () {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss">
  @import '../variables.scss';
  .spl-edit-tabs {
    .tabs-component-panels {
      padding: 0 $mainPadding;
    }
    .tabs-component-tabs {
      background-color: $yellowButtonLabelHover;
      padding: 3px $mainPadding 13px $mainPadding;
      margin: 0;
      display: flex;
      .tabs-component-tab {
        color: white;
        padding-bottom: 5px;
        margin: 12px 10px 0 10px;
        list-style: none;
        font-size: 14px;
        &.is-active {
          color: #ebaa28;
          border-bottom: 2px solid #ebaa28;
        }
      }
    }
  }
</style>
